import type { ServerColDef } from '@cmg/data-grid';
import { createValueFormatter } from '@cmg/data-grid';

import type { FirmInvestorContactsGridItemFragment } from '../graphql/__generated__';

export const valueFormatter = createValueFormatter<
  FirmInvestorContactsGridItemFragment,
  FirmInvestorContactsGridItemFragment['investorEmployeeKey']
>();

export const investorEmployeeKeyColDef: ServerColDef<FirmInvestorContactsGridItemFragment> = {
  field: 'investorEmployeeKey',
  headerName: 'Employee Key',
  valueFormatter,
};
